import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'branch-working-hours',
    templateUrl: './working-hours.component.html',
    styleUrls: ['./working-hours.component.scss']
})
export class WorkingHoursComponent implements OnInit, OnChanges {
    ngOnChanges(changes: SimpleChanges): void {
        let newValue = changes['BusinessWeek'].currentValue;
        this.getWorkingDaysAndHours();
    }
    @Input("BusinessWeek") BusinessWeek: IWorkingHours;
    workingDays: string[] = [];
    businessHours: string[] = [];
    allDays = ["SAT", "SUN", "MON", "TUE", "WED", "THU", "FRI"];
    notWorkingDays: string[] = [];
    constructor(private translate: TranslateService) {
    }

    getDayName(d) {
        switch (d) {
            case 'SAT':
                return `${this.translate.instant('pages.branchManagementPage.workingHours.saturday')}`;
                break;
            case 'SUN':
                return `${this.translate.instant('pages.branchManagementPage.workingHours.sunday')}`;
                break;
            case 'MON':
                return `${this.translate.instant('pages.branchManagementPage.workingHours.monday')}`;
                break;
            case 'TUE':
                return `${this.translate.instant('pages.branchManagementPage.workingHours.tuesday')}`;
                break;
            case 'WED':
                return `${this.translate.instant('pages.branchManagementPage.workingHours.wednesday')}`;
                break;
            case 'THU':
                return `${this.translate.instant('pages.branchManagementPage.workingHours.thursday')}`;
                break;
            case 'FRI':
                return `${this.translate.instant('pages.branchManagementPage.workingHours.friday')}`;
                break;
            default:
                return '';
                break;
        }
    }

    getWorkingDaysAndHours() {
        if (this.BusinessWeek.WorkingDays) {
            this.workingDays = this.BusinessWeek.WorkingDays.split(",", 7);
            this.businessHours = this.BusinessWeek.BusinessHours.split("-", 2);

            for (var i = 0; i < this.allDays.length; i++) {
                if (!this.allDays.includes(this.workingDays[i])) {
                    this.notWorkingDays.push(this.workingDays[i])
                }

            }

        }
    }

    ngOnInit() {
    }

}
